
<n-modal-background v-if="modals.length" ref="bg" :closeOnOutside="false" :closeOnEscape="false">
  <component
    v-for="config in modals"
    :key="config.id"
    :is="config.variant === 'confirm' ? 'NConfirm' : 'NAlert'"
    :title="config.title"
    :confirmButtonText="config.confirmButtonText"
    :confirmButtonIcon="config.confirmButtonIcon"
    :confirmLoading="config.id === confirmingModalId"
    @confirm="handleConfirm(config)"
    @cancel="handleCancel(config)"
    @close="handleClose(config)"
  >
    {{ config.message }}
  </component>
</n-modal-background>
